import {
  fetchGeneral,
  fetchGraphQL
} from '../Connections';

import {
  getFieldListString
} from './util';

export function queryGetPayors(variables, fields) {
  const query = `
    query listPayors(
      $limit: Int,
      $offset: Int,
      $filters: [Filter],
      $filter_expressions: [FilterExpression],
      $order: Order,
      $orders: [Order]
    ) {
      listPayors(
        limit: $limit,
        offset: $offset,
        filters: $filters,
        filter_expressions: $filter_expressions,
        order: $order,
        orders: $orders
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function queryGetPayor(variables, fields) {
  const query = `query getPayor($payor_id: String!) {
    getPayor(payor_id: $payor_id) {
      ${getFieldListString(fields)}
    }
  }`

  return fetchGraphQL({ query, variables });
}

export function queryUpdatePayor(variables, fields) {
  const query = `mutation updatePayor(
    $payor: PayorInput!,
    ) {
    updatePayor(
      payor: $payor,
    ) {
      ${getFieldListString(fields)}
    }
  }`

  return fetchGraphQL({ query, variables });
}

export function queryUpdateSubscription(variables, fields) {
  const query = `mutation updateSubscription(
    $subscription: SubscriptionInput,
    $subscription_id: String!,
    ) {
    updateSubscription(
      subscription: $subscription,
      subscription_id: $subscription_id,
    ) {
      ${getFieldListString(fields)}
    }
  }`

  return fetchGraphQL({ query, variables });
}

export function queryCreatePayor(variables, fields) {
  const query = `mutation createPayor(
    $new_payor_password: String!,
    $payor: PayorInput!,
    $copy_billing_to_alternate: Boolean
  ) {
    createPayor(
      new_payor_password: $new_payor_password,
      payor: $payor,
      copy_billing_to_alternate: $copy_billing_to_alternate
    ) {
      ${getFieldListString(fields)}
    }
  }`

  return fetchGraphQL({ query, variables });
}

export function queryGetPayorReport(options) {
  return fetchGeneral('/payor_report', {
    method: 'POST',
    body: JSON.stringify(options)
  });
}

export function queryCreateCustomerNote(variables) {
  const query = `
    mutation createCustomerNote($payor_id: String!, $customer_note: CustomerNoteInput!) {
      createCustomerNote(payor_id: $payor_id, customer_note: $customer_note) {
        id,
        payor_id,
        text,
        created_by,
        created_at
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function queryUpdatePayorCognitoSub(variables, fields) {
  const query = `
    mutation reassignPrimaryContact($level: ReassignPCLevelEnum!, $payor: PayorInputForReassignPC!, $subscriptionId: String!, $newUserId: String!, $newEmail: String!) {
      reassignPrimaryContact(level: $level, payor: $payor, subscriptionId: $subscriptionId, newUserId: $newUserId, newEmail: $newEmail)
    }
  `;

  return fetchGraphQL({ query, variables });
}

export function queryGetCognitoSub(variables) {
  const query = `
    query getCognitoSub($email: String!) {
      getCognitoSub(email: $email)
    }
  `;

  return fetchGraphQL({ query, variables });
}